import { render } from "./CortonaIPC.vue?vue&type=template&id=0da2bb76&scoped=true"
import script from "./CortonaIPC.vue?vue&type=script&lang=js"
export * from "./CortonaIPC.vue?vue&type=script&lang=js"

import "./CortonaIPC.vue?vue&type=style&index=0&id=0da2bb76&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.9.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da2bb76"]])

export default __exports__